export default __webpack_public_path__ + "static/media/y_lightblue.62530139.png";